<template>
	<header-block title="Complete your purchase" border="0"></header-block>
	<CustomerLoadWait :customer="availableVoucher" />
	<transition>
		<div v-if="availableVoucher" class="wrapper">
			<div class="cart">
				<v-btn v-if="paymentLoading && !paymentResponse" :flat="true" class="mt-7 mg-button" :disabled="true"><v-progress-circular indeterminate /></v-btn>
				<StripeCheckout class="mt-2" v-if="paymentResponse" :secret="paymentResponse.paymentLink" :stripeKey="$route.meta.stripeKey" />
				<p class="centered constraints small mt-6"><v-icon style="margin-top:-4px;" icon="mdi-lock"></v-icon> Payments are protected by bank grade encryption.</p>
			</div>
		</div>
	</transition>

	<DrawerPanel v-if="availableVoucher && availableVoucher.stackWith && availableVoucher.stackWith.length > 0" ref="doubleDrawer" openHeight="70%" bottom="-10px" closedHeight="0" title="What is Double Bubble?" backgroundColor="white" openBackgroundColor="white">
		<div class="simplePage">
			<h1>Double Bubble?</h1>
			<v-icon icon="mdi-circle-double" class="heroImg" />
			<p>Double Bubble allows you to combine a Money Guided cashback voucher with another discount at point of sale to double down on your savings!</p>
			<p>For example, at {{ availableVoucher.merchant.name }}, you may be able to use your {{ availableVoucher.stackWith[0] }} at point of sale and get a discount on your final bill, then use a Money Guided cashback voucher to pay, saving you a lot more!</p>
			<p>Check your {{ availableVoucher.stackWith[0] }} to see what you can combine with Money Guided vouchers at {{ availableVoucher.merchant.name }}.</p>
			<p><small>While we try our best to highlight potential opportunities for Double Bubble, your mileage may vary.</small></p>
		</div>
	</DrawerPanel>
	
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import StripeCheckout from './elements/StripeCheckout.vue';
import DrawerPanel from './elements/DrawerPanel.vue';

export default {
	mixins: [Services],
	components: {CustomerLoadWait, HeaderBlock, StripeCheckout, DrawerPanel},
	data() {
		return {
			useCredit: false,
			total: null,
			subTotal: null,
			processingFee: null,
			amountToPayToday: null,
			errorText: null,
			paymentLoading: false,
			paymentResponse: null,
			paymentPending: false,
			voucherResponse: null,
			closable: true,
			showAll: false,
			guide: null
		}
	},
	methods: {

		onLoad: async function() {
			if (this.$route.query.total !== undefined) {
				this.total = parseFloat(this.$route.query.total);
			}
			if (this.$route.query.subTotal !== undefined) {
				this.subTotal = parseFloat(this.$route.query.subTotal);
			}
			if (this.$route.query.processingFee !== undefined) {
				this.processingFee = parseFloat(this.$route.query.processingFee);
			}
			if (this.$route.query.useSavedToSpend !== undefined) {
				this.useCredit = this.$route.query.useSavedToSpend === 'true' || this.$route.query.useSavedToSpend === true;
			}
			if (this.$route.query.amountToPayToday !== undefined) {
				this.amountToPayToday = parseFloat(this.$route.query.amountToPayToday);
			}
			if (this.$route.query.faceValue !== undefined) {
				this.faceValue = parseFloat(this.$route.query.faceValue);
			}
			this._getCustomer();
			this._getCustomerVouchers();
			this._getAvailableVoucher(this.$route.params.id, () => {
				this._removeUnavailableDiscountProviders(this.availableVoucher);
				this._getCustomerFavouriteVouchers((f) => {
					if (this.availableVoucher && f && f.length > 0) {
						this.availableVoucher.favourite = f.some(fav => fav.id === this.availableVoucher.id);
					}
				});
				this._getCmsArticleByKey(("VG_" + this.availableVoucher.merchant.name.replaceAll("&",'').toUpperCase()).substring(0,10), (article) => {
					if (article) {
						this.guide = article;
					}
				});
				
				if (this.total && !this.paymentLoading && !this.paymentResponse) {
					this.stripePay();
				}
			});
		},

		toggleDrawer: function() {
			this.$refs.termsDrawer.toggleDrawer();
		},

		stripePay: function() {
			this.paymentLoading = true;
			this.closable = false;
			var meta = {
				type: "voucher", 
				voucherId: this.availableVoucher.id,
				slug: this.availableVoucher.merchant.slug, 
				amount: this.faceValue
			}
			var paymentRequest = {
				meta: JSON.stringify(meta),
				useVoucherCredit: this.useCredit,
				type:1,
				returnUrl: window.location.href.split("#")[0] + "#/PaymentComplete",
				amountInPence: parseInt(Math.round(parseFloat(this.faceValue) * 100)),
				productDescription: "MG " + this.availableVoucher.merchant.name + " Voucher",
				paymentReference: this.availableVoucher.merchant.name.length > 22 ? this.availableVoucher.merchant.name.substring(0,22) : this.availableVoucher.merchant.name
			}
			this._createPayment(paymentRequest, (response) => {
				this.paymentResponse = response.data;
				this.paymentPending = true;
			});
		},

		toggleFavourite: function() {
			if (this.availableVoucher.favourite) {
				this._removeCustomerFavouriteDiscount(this.availableVoucher, () => {
					this.availableVoucher.favourite = false;
				});
			} else {
				this._addCustomerFavouriteDiscount(this.availableVoucher, () => {
					this.availableVoucher.favourite = true;
				});
			}
		},

		showDoubleBubble: function() {
			this.$refs.doubleDrawer.openDrawer();
		},

		calcCashback: function(amount) {
			if (amount && this.availableVoucher && this.availableVoucher.effectiveDiscountPercentage) {
				var cashback = amount * (this.availableVoucher.effectiveDiscountPercentage / 100);
				return this.formatter.format(cashback);
			}
			return "£0 cashback";
		},

	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>
	.amount {
		text-align: right !important;
		float: right;
	}
	.merchantName {
		white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
	}

	.paymentMethods {
		position: relative;
		width: 200px;
		margin: 20px auto 0 auto;
	}

	.cashback {
		background: #FCE5D4;
		color: var(--text-color);
		font-size: 11px;
		padding: 6px 8px;
		border-radius: 4px;
	}

	.cashback-zero {
		background: transparent;
		color: var(--text-color);
		border: 1px solid #FCE5D4;
		border-radius: 4px;
	}

	.icon-col {
		margin-left: -7px;
	}

	.icon {
		width: 72px;
		background-color: #E7ECF7;
		border-radius: 10px;
		margin-top: 10px;
	}	

	.online-icon {
		height: 16px;
		width: 12px;
		margin: 0 auto;
		background-color: transparent;
		filter: invert(1);
	}

	.in-store-icon {
		height: 16px;
		width: 16px;
		margin: 0 auto;
		background-color: transparent;
		filter: invert(1);
	}

	.online-icon + .in-store-icon {
		margin-left: 5px;
	}

	/* Add spacing between the spans when both online and in-store are present */
	v-span:has(.online-icon) + v-span:has(.in-store-icon) {
		margin-left: 10px;
	}

	.icon-col {
		position: relative;
	}

	.favouriteIconChip {
		position: absolute;
		right: -1px;
		top: 80px;
	}

	.categoryImage {
		margin-left: -30px;
		margin-right: -30px;
		margin-top: -10px;
		width: 110vw;
		height: 160px;
		object-fit: cover;
	}

	h1 {
		font-size: 24px;
	}
	.header {
		margin-top: -138px;
		padding: 30px;
		padding-top: 138px;
		color: white;
		padding-bottom: 200px;
	}
	.logo-col {
		text-align: right;
	}
	.logo-col img {
		width: 70px;
		border-radius: 40px;
		padding: 5px;
		background-color: white;
	}
	.percentage {
		font-size: 16px;
		font-weight: bold;
		margin-top: -5px;
	}
	p{
		font-size: 13px;
	}
	.cart {
		padding: 30px;
		margin-top: -30px;
		margin-left: -15px;
		margin-right: -15px;
		border-radius: 12px;
		padding-bottom: 40px;
		h2 {
			margin-bottom: 15px;
		}
		.constraints {
			margin-top: 10px;
			padding-top: 0px;
		}
		.small {
			font-size: 11px;
		}
		position: relative;
	}
	.howto {
		background-color: var(--background-color-alt);
		padding: 30px;
		margin-top: 20px;
		border-radius: 12px;
		padding-bottom: 35px;
		font-weight: normal;
		font-size: 11px;
		h2 {
			margin-bottom: 15px;
		}
		.constraints {
			margin-top: -10px;
			padding-top: 0px;
		}
		.small {
			font-size: 11px;
		}
		ul{
			padding-left: 20px;
			padding-right: 20px;
			font-size: 11px;
		}
	}
	.fromBrand {
		.v-col {
			padding-top: 0px;
		}
	}
	.cancel{
		position: absolute;
		right: 20px;
		top: 20px;
		
	}
	.descriptionWrapper {
		text-overflow: ellipsis;
		margin-bottom: 5px;
	}

	.wrapper {
		padding-bottom: 30px;
	}

	.simplePage {
		.heroImg {
			font-size: 40px;
			color: var(--text-color);
			margin-top: 20px;
			margin-bottom: 30px;
		}
	}

</style>
